<ng-form class="m-t-2"
  #stepForm="ngForm">
  @if (isSelected() && isCcvRequired()) {
    <input-wrap class="w-12"
      label="CVV:"
      >
    <span class="cvv-input pos-relative">
      <input class="input b-a b-col-5 m-t-1 cvv-input"
        [(ngModel)]="cvc"
        placeholder="CVV"
        type="text"
        pattern="[0-9]*"
        inputmode="numeric"
        name="cvc"
        required
        minlength="3"
        maxlength="4"
        autocomplete="off" />
      <span class="pos-absolute right-0 top-0 bottom-0 flex flex-middle">
        <i class="icon-cvv"></i>
      </span>
    </span>
  </input-wrap>
}
</ng-form>
